import mapboxgl from 'mapbox-gl';
const MapBox = {
    popup : new mapboxgl.Popup(),
    toolTip : (e) => {
        var tooltip = document.createElement('div');
            tooltip.setAttribute('class', 'tooltip');
            tooltip.setAttribute('id', `tooltip-${e.features[0].properties.id}`);
            // tooltip.setAttribute('style', `left: ${e.point.x}px; top: ${e.point.y}px;`);
            tooltip.textContent = e.features[0].properties.title;

        var mapDiv = document.getElementById('map');
        mapDiv.appendChild(tooltip);

        setTimeout(() => {
            tooltip.classList.add('tooltip-visible');
        }, 100);
    },

    getLinks : (links) => {
        var linkArr;
        if (typeof links == 'string') {
            linkArr = JSON.parse(links);
        } else {
            linkArr = links;
        }

        var link = '';

        linkArr.sort(function(obj1, obj2) {
            return obj1.order - obj2.order;
        });
        for (let i = 0; i < linkArr.length; i++) {
            link += linkArr[i].url == '' ? '<li>' + linkArr[i].title + '</li>' : '<li><a target="_blank" href="' + linkArr[i].url + '">' + linkArr[i].title + '</a></li>';
        }
        return link;
    },

    getContacts : (links) => {
        var linkArr;
        if (typeof links == 'string') {
            linkArr = JSON.parse(links);
        } else {
            linkArr = links;
        }

        var link = '';

        linkArr.sort(function(obj1, obj2) {
            return obj1.order - obj2.order;
        });
        for (let i = 0; i < linkArr.length; i++) {
            link += '<li>' + linkArr[i].text + '</li>';
        }
        return link;
    },

    popUp : (e , map) => {
        let features = e.features ? e.features[0] : e ;

        //return false;
        let properties = features.properties;
        let latLong = features.geometry.coordinates;
        let titleAr = properties.title_ar ? '<div class="mapboxgl-popup-title-ar" dir="rtl">' + properties.title_ar + '</div>' : '';
        let html = '<div class="mapboxgl-popup-inner">' +
                        '<h3 class="mapboxgl-popup-title">' + properties.title + '</h3>' +
                        titleAr +
                        '<div class="mapboxgl-popup-img" style="background-image: url(' + properties.img + ');"></div>' + 
                        '<ul class="no-list mapboxgl-popup-links">' + MapBox.getLinks(properties.links) + '</ul>' + 
                        '<ul class="no-list mapboxgl-popup-links">' + MapBox.getContacts(properties.contact) + '</ul>' + 
                        '<div>' + properties.id.trim().toLowerCase().replace('po-','<img src="https://www.uaeu.ac.ae/images/map/map-pin.png"> '); + '</div>' + 
                    '</div>';
        
        
                    
                
        setTimeout(() => {
            MapBox.popup.setLngLat(latLong).setHTML(html).addTo(map);
            
        }, 100);

        MapBox.popup.remove();

        map.flyTo({
            center: latLong,
            speed: 0.2,
            zoom: 16
        });

    }
}
export default MapBox;



// WEBPACK FOOTER //
// ./src/utils/Mapbox.js